<template>
  <!-- 全局底部导航 -->
  <div class="footerNav-wrap">
    <div class="box">
      <p><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33040202001030" style="display: inline-block;text-decoration: none;height: 20px;line-height: 20px;text-shadow: 0px 0px;">
        <img src="https://static.meetime.com/beian.png" style="float: left;width: 1vw">
        浙公网安备33040202001030号
      </a>｜<a target="_blank" href="http://beian.miit.gov.cn/" style="display: inline-block;text-decoration: none;height: 20px;line-height: 20px;text-shadow: 0px 0px;">
        浙ICP备2024136216号-2
      </a>｜<span class="about" @click="router.push('/aboutUs')">{{ $t("关于我们") }}</span></p>
      <p>
        Copyright @2007-2023 ASV(DALIAN) CO.,LTD. All Rights Reserved
      </p>
    </div>
  </div>
  <join-tip :passShow="isJoinTipShow" @closeToast="isJoinTipShow = false"></join-tip>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import {ref} from "vue";

const router = useRouter();

const route = useRoute();
// 弹窗
const isJoinTipShow = ref(false);
</script>

<style src="./footerNav.css" scoped></style>
